var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDoubleUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5377 10.2371C22.8208 9.946 22.8208 9.48257 22.5377 9.19147L16.9822 3.47719C16.6935 3.1802 16.2186 3.17351 15.9216 3.46225C15.6246 3.75099 15.618 4.22582 15.9067 4.52281L20.954 9.71428L15.9067 14.9058C15.618 15.2028 15.6246 15.6776 15.9216 15.9663C16.2186 16.2551 16.6935 16.2484 16.9822 15.9514L22.5377 10.2371Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0172 10.2574C18.1659 10.1159 18.25 9.91956 18.25 9.7143C18.25 9.50905 18.1659 9.31276 18.0172 9.1712L12.0172 3.45691C11.8 3.25 11.4803 3.19248 11.2046 3.31066C10.9288 3.42884 10.75 3.7 10.75 4.00002V8.9643H5C2.92893 8.9643 1.25 10.6432 1.25 12.7143V20C1.25 20.4142 1.58579 20.75 2 20.75C2.41421 20.75 2.75 20.4142 2.75 20V12.7143C2.75 11.4717 3.75736 10.4643 5 10.4643H10.75V15.4286C10.75 15.7286 10.9288 15.9998 11.2046 16.1179C11.4803 16.2361 11.8 16.1786 12.0172 15.9717L18.0172 10.2574Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDoubleUpRight);
export default __webpack_public_path__ + "static/media/corner-double-up-right.677d9056b34b6c18d7c0ffdc5c608917.svg";
export { ForwardRef as ReactComponent };